<template>
  <div class="ibox">
    <div class="ibox-content">
      <div class="row">
        <div class="col-lg-12">
          <div class="m-b-md">
            <h2>
              <router-link :to="`/admin/templates/${id}`">{{ name }}</router-link>
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TemplateCard',
  props: {
    id: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    subject: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'PROGRAMMING',
    },

  },
  methods: {
    handleEdit() {
      this.$emit('onEdit');
    },
    handleDelete() {
      this.$emit('onDelete');
    },
    handleCommand(command) {
      const commands = {
        edit: this.handleEdit,
        delete: this.handleDelete,
      };
      return commands[command]();
    },
  },
};
</script>

<style lang="scss" scoped>
.no-channels {
  text-align: center;
  font-size: 1.2em;
  color: #ccc;
  text-shadow: 1px 1px 1px #efefef;
}
.favourite {
  font-size: 19px;
  margin-right: 8px;
  cursor: pointer;

  &.inactive {
    color: #ccc;
  }

  &.active {
    color: #fce205;
  }
}

dt,
dd {
  padding: 3px 0;
}
</style>



// WEBPACK FOOTER //
// TemplateCard.vue?4b3ece28